
<template>
  <ul class="content">
    <li v-for="(category, $index) in categories">
      <div class="setting bb">
        <h5 class="title">{{ category.name }}</h5>
        <toggle-button
          color="#3cf"
          v-model="category.enabled"
          @change="toggleCategory($event, category.id, $index)"
          :sync="true"
          class="toggleButton"
        />
        <i
          class="fa fa-plus"
          v-if="!category.open"
          @click="category.open = true"
        ></i>
        <i class="fa fa-minus" v-else @click="category.open = false"></i>
      </div>

      <ul class="indent" v-show="category.open">
        <li v-for="event in category.bulletin_events">
          <div class="category-title">{{ event.name | deCamelCase }}</div>
          <p>{{ event.description }}</p>
          <div class="setting">
            <toggle-button
              color="#3cf"
              v-model="event.enabled"
              :sync="true"
              @change="changeSettings([event.id], ['enabled'], $event.value)"
              class="toggleButton no-margin"
            />
            Receive Portal Notifications
          </div>
          <div class="setting">
            <toggle-button
              color="#3cf"
              v-model="event.email"
              :sync="true"
              @change="changeSettings([event.id], ['email'], $event.value)"
              class="toggleButton no-margin"
            />
            Receive Email Notifications
          </div>
          <div class="setting">
            <toggle-button
              color="#3cf"
              v-model="event.push"
              :sync="true"
              @change="changeSettings([event.id], ['push'], $event.value)"
              class="toggleButton no-margin"
            />
            Receive Push Notifications
          </div>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import bulletins from "../../services/bulletins";

export default {
  data() {
    return {
      categories: null,
      openCategory: 0
    };
  },
  mounted() {
    this.getSettings();
  },
  methods: {
    getEvents() {
      bulletins.getCategories().then((response) => {
        this.categories = response.map((c) => {
          c.bulletin_events = c.bulletin_events.map((e) => {
            const setting = this.settings.find((s) => {
              return s.eventId === e.id;
            });
            if (!setting) {
              console.log(e)
              return e;
            }
            e.enabled = setting.enabled;
            e.email = setting.email;
            e.push = setting.push;
            if (e.enabled || e.email || e.push) {
              c.enabled = true;
            }
            return e;
          });
          c.open = false
          return c;
        });
      });
    },
    changeSettings(eventIds, types, value) {
      bulletins.changeSettings(eventIds, types, value);
    },
    getSettings() {
      bulletins.getSettings().then((response) => {
        this.settings = response.settings;
        this.getEvents();
      });
    },
    toggleCategory(event, id, index) {
      const category = this.categories[index];
      const categoryEvents = category.bulletin_events.map((e) => {
        return e.id;
      });
      const types = ["enabled", "email", "push"];

      this.categories[index].bulletin_events.forEach((e) => {
        types.forEach((t) => {
          e[t] = event.value;
        });
      });
      this.changeSettings(categoryEvents, types, event.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.setting {
  display: flex;
  align-items: center;

  .title {
    font-weight: 600;
  }

  .toggleButton {
    margin: 0rem 1rem;
    margin-bottom: 6px;

    &.no-margin {
      margin-left: 0;
    }
  }
}

.indent {
  overflow: hidden;
  background: #0f0f0f63;
  border: solid 1px transparent;

  li {
    margin-left: 1.5rem;
  }
}

.category-title {
  color: white;
}

p {
  font-style: italic;
}

li {
  margin-top: 1rem;
  margin-bottom: 3rem;
}

.bb {
  border-bottom: rgba(255, 255, 255, 0.212) solid 1px;

  i {
    margin-left: auto;
    cursor: pointer;

    &:hover {
      color: white;
    }
  }
}
</style>


// WEBPACK FOOTER //
// BulletinSettings.vue?ef5edf4a